
//prod

export const base_url = "https://bjpodisha.org/karyalays/";

//dev

// export const base_url = "https://nirmalya.store/karyalays/";
